<style lang="scss" scoped src="./style/index.scss"></style>
<style lang="scss" src="../reset/style/stepDialog.scss"></style>
<style lang="scss">
.page-editPwd {
  height: 100%;

  .stepDialog {
    .addImpowerDialogFooter {
      display: inline-block;
      padding-left: 180px;
      width: 100%;
      @media screen and (max-device-width: 400px) {
        padding-left: 0;
      }

      .el-button {
        margin-left: 0;
        @media screen and (max-device-width: 400px) {
          width: 100%;
        }
      }
    }

    .step-item {
      padding-right: 80px;
      @media screen and (max-device-width: 400px) {
        padding-right: 0;
      }
    }

    .el-form-item.is-error {
      margin-bottom: 24px;
    }
  }

  .rule-infor {
    margin-top: 64px;

    &__item {
      color: #8e8e8f;
      font-size: 12px;
      line-height: 18px;
      margin: 0;
      padding: 0;

      &-highlight {
        color: darkorange;
      }
    }
  }

  .error-msg {
    color: #e0563d;
    font-size: 12px;
    line-height: 12px;
    margin-top: 5px;
    position: absolute;
  }

  .el-input__suffix {
    font-size: 20px;
    right: 8px;
  }
}
</style>
<template>
  <div class="page-editPwd app-page">
    <step-dialog
      ref="stepDialog"
      model="inner"
      :step.sync="stepIndex"
      :options="stepOpt"
      :finish="finish"
      :next="next"
      v-if="stepDialogShow"
    >
      <div slot="step-1">
        <div class="step-item">
          <login-form
            @keyup-submit="onKeyup"
            v-if="stepIndex === 1"
            ref="captchaForm"
            :formData="captchaForm"
            :formDataRule="captchaFormRule"
            @onLogin="login"
          ></login-form>
        </div>
      </div>
      <div slot="step-2">
        <div class="step-item">
          <new-pwd
            @keyup-submit="onSubmit"
            ref="newPwd"
            :model="editPwdForm"
            :current-user-info="currentUserInfo"
            v-if="currentPageType === 'password'"
            :errorMsg="errorMsg"
          ></new-pwd>
          <mobile-login
            @keyup-submit="onSubmit"
            ref="editMobileForm"
            :formData="editMobileForm"
            :formDataRule="editMobileFormRule"
            v-if="currentPageType === 'mobile' && stepIndex === 2"
          ></mobile-login>
        </div>
      </div>
    </step-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import newPwd from "../reset/newPwd.vue";
import loginForm from "./login.vue";
import mobileLogin from "@/views/app-cloud/reset/login.vue";

export default {
  name: "appCloudUnfreeze",
  components: {
    newPwd,
    loginForm,
    mobileLogin,
  },
  beforeRouteEnter(to, from, next) {
    if (isNaN(to.params.step)) {
      next("/");
      return;
    }
    let title = "";
    if (to.params.type === "password") {
      title = "editPwd";
    } else if (to.params.type === "mobile") {
      title = "editMobile";
    }
    next((vm) => {
      vm.$store.dispatch("appCloudHeaderStore/changeTitle", title);
    });
  },
  data() {
    const currentPageType = this.$route.params.type;
    return {
      errorMsg: "",
      pwdType: "password",
      captchaLoading: false,
      intervalId: "",
      captchaDisabled: false,
      currentPageType,
      acountSureForm: {
        account: "",
        captcha: "",
      },
      captchaForm: {
        account: "",
        challenge: "",
        password: "",
      },
      editPwdForm: {
        account: "",
        oldPwd: "",
        newPwd: "",
        pwdSure: "",
        captcha: "",
      },
      captchaSrc:
        "https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2923402160,3561321972&fm=27&gp=0.jpg",
      currentInfor: {
        encryptionCode: null,
        mobile: "",
      },
      currentUserInfo: {
        userName: "",
        employeeNo: "",
        domainAccount: "",
        mobile: "",
      },
      stepDialogShow: true,
      editMobileForm: {
        areaCode: 86,
        mobile: "",
        captcha: "",
        smscode: "",
      },
    };
  },
  watch: {
    currentPageStep(val) {
      this.stepIndex = Number(val);
    },
  },
  computed: {
    ...mapState({
      pageHeight: (state) => state.appCloudLayoutStore.bodyMinHeight,
      rule: (state) => state.appCloudLayoutStore.rules,
    }),
    stepIndex: {
      get() {
        const step = Number(this.$route.params.step);
        if (step === 2) this.getCurrentUserInfo();
        return step;
      },
      set(val) {
        if (val === 2) this.getCurrentUserInfo();
        this.stepDialogShow = false;
        this.$nextTick(() => {
          this.stepDialogShow = true;
        });
      },
    },
    currentPageStep() {
      return this.$route.params.step;
    },
    pageStyle() {
      return {
        height: `${this.pageHeight}px`,
      };
    },
    stepOpt() {
      return [
        {
          title: this.$t("i18n.authentication"),
          btn: this.$t("i18n.nextStep"),
          "prev-btn-hide": true,
        },
        {
          title:
            this.currentPageType === "password"
              ? this.$t("i18n.setNewPwd")
              : this.$t("i18n.setNewMobile"),
          btn: this.$t("i18n.finish"),
          "prev-btn-hide": true,
        },
      ];
    },
    captchaFormRule() {
      const { rule } = this;
      // const geetestVal = (rules, value, callback) => {
      //   if (!this.$refs.captchaForm.g.validate) callback(new Error('请完成验证'));
      //   else callback();
      // };
      return {
        account: rule.adminAccount(1, 255, this.$t("i18n.accountErrMsg")),
        password: rule.adminAccount(1, 32, this.$t("i18n.pwdPlaceholder")),
      };
    },
    editMobileFormRule() {
      const { rule } = this;
      let mobileRule = rule.mobile(
        1,
        11,
        this.$t("i18n.phonePlaceholder"),
        this.$t("i18n.invalidFormat")
      );
      if (this.editMobileForm.areaCode !== 86) {
        mobileRule = [
          {
            required: true,
            message: this.$t("i18n.phonePlaceholder"),
            trigger: "blur",
          },
          {
            min: 1,
            message: this.$t("i18n.invalidFormat"),
            trigger: "blur",
          },
        ];
      }
      return {
        captcha: rule.captcha(1, 32, this.$t("i18n.cptPlaceholder")),
        mobile: mobileRule,
        smscode: rule.captcha(1, 32, this.$t("i18n.cptPhonePlaceholder")),
      };
    },
    publickey() {
      return this.$store.state.appCloudLayoutStore.secret;
    },
  },
  methods: {
    submitEditMobile(resolve, done) {
      const params = {
        areaCode: this.editMobileForm.areaCode,
        mobile: this.editMobileForm.mobile,
        smscode: this.editMobileForm.smscode,
        captcha: this.editMobileForm.captcha,
      };
      this.$api.mobileUpdate
        .updateMobile(params)
        .then((res) => {
          this.$router.push("/statePage/success");
          resolve(res);
        })
        .catch((err) => {
          this.$refs.editMobileForm.getCaptchaImgVersion();
          done(err);
        });
    },
    submitEditPwd(resolve, done) {
      this.$store.dispatch("appCloudLayoutStore/getPublicKey").then((res) => {
        if (res.code === "success") {
          const param = {
            password: this.editPwdForm.pwdSure,
          };
          this.$api.passwordupdate
            .updatePassword(param)
            .then((response) => {
              this.$router.push("/statePage/success");
              resolve(response);
            })
            .catch((err) => {
              this.$message.error(this.$t(`ajax.${err.CODE || err.code}`));
              this.errorMsg = this.$t(`ajax.${err.CODE || err.code}`);
              done(err);
            });
        }
      });
    },
    finish(data, resolves, done) {
      if (this.currentPageType === "password") {
        const promise = new Promise((resolve) => {
          this.$refs.newPwd.getValidResault((valid) => {
            if (valid) {
              // 修改密码
              this.submitEditPwd(resolve, done);
            } else {
              setTimeout(() => {
                done();
              });
            }
          });
        });
        resolves(promise);
      } else if (this.currentPageType === "mobile") {
        this.$refs.editMobileForm.$refs.formData.validate((valid) => {
          if (valid) {
            const promise = new Promise((resolve) => {
              this.submitEditMobile(resolve, done);
            });
            resolves(promise);
          }
          // else {
          //   return false;
          // }
        });
      }
    },
    next(value, next, step) {
      if (step === 1) {
        this.$refs.captchaForm.$refs.formData.validate((valid) => {
          if (valid) {
            this.$refs.captchaForm.verify();
            return true;
          }
          return false;
        });
      }
    },
    login() {
      this.$refs.stepDialog.loading = true;
      this.$store.dispatch("appCloudLayoutStore/getPublicKey").then(() => {
        const params = this.captchaForm;
        let Ajax = this.$api.passwordupdate.login;
        if (this.currentPageType === "mobile") {
          Ajax = this.$api.mobileUpdate.login;
        }
        Ajax(params)
          .then(() => {
            this.$refs.stepDialog.loading = false;
            this.$router.push(`/edit/${this.currentPageType}/2`);
          })
          .catch((err) => {
            this.$refs.stepDialog.loading = false;
            if (err.CODE === "GT_VERIFY_STATUS_NO_EXIST") {
              this.$refs.captchaForm.refreshInitGeetest();
            }
          });
      });
    },
    getCurrentUserInfo() {
      this.$api.passwordupdate.currentUser().then((res) => {
        if (res.code === "success") {
          this.currentUserInfo = Object.assign(this.currentUserInfo, res.data);
        }
      });
    },
    onKeyup() {
      this.$refs.stepDialog.nextStep();
    },
    onSubmit() {
      this.$refs.stepDialog.stepfinish();
    },
  },
};
</script>
